import React from 'react';
import { Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined, PhoneOutlined, HomeOutlined, BankOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import './Register.css';

const Register = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      const response = await axios.post('/api/users/register/', values);
      
      if (response.status === 201) {
        message.success(response.data.message);
        form.resetFields();
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || '注册失败，请稍后重试';
      message.error(errorMessage);
    }
  };

  return (
    <div className="register-container">
      <div className="register-form">
        <h1>用户注册</h1>
        <div className="login-button-container">
          <Link to="/login" className="login-link">
            登录
          </Link>
        </div>
        <Form
          form={form}
          name="register"
          onFinish={onFinish}
          scrollToFirstError
          layout="vertical"
        >
          <Form.Item
            className="register-form-item"
            name="username"
            rules={[
              {
                required: true,
                message: '请输入用户名！',
              },
              {
                min: 3,
                message: '用户名长度至少为3位！',
              },
              {
                max: 20,
                message: '用户名长度不能超过20位！',
              },
              {
                pattern: /^[a-zA-Z0-9_]+$/,
                message: '用户名只能包含字母、数字和下划线！',
              }
            ]}
          >
            <Input 
              className="register-input"
              prefix={<UserOutlined className="register-input-prefix" />} 
              placeholder="用户名" 
            />
          </Form.Item>

          <Form.Item
            className="register-form-item"
            name="password"
            rules={[
              {
                required: true,
                message: '请输入密码！',
              },
              {
                min: 8,
                message: '密码长度至少为8位！',
              },
              {
                max: 30,
                message: '密码长度不能超过30位！',
              },
              {
                pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};:'",.<>/?\\|])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};:'",.<>/?\\|]+$/,
                message: '密码必须包含大小写字母、数字和特殊字符！',
              }
            ]}
          >
            <Input.Password 
              className="register-input"
              prefix={<LockOutlined className="register-input-prefix" />} 
              placeholder="密码" 
            />
          </Form.Item>

          <Form.Item
            className="register-form-item"
            name="password2"
            dependencies={['password']}
            rules={[
              {
                required: true,
                message: '请确认密码！',
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('两次输入的密码不匹配！'));
                },
              }),
            ]}
          >
            <Input.Password 
              className="register-input"
              prefix={<LockOutlined className="register-input-prefix" />} 
              placeholder="确认密码" 
            />
          </Form.Item>

          <Form.Item
            className="register-form-item"
            name="email"
            rules={[
              {
                type: 'email',
                message: '请输入有效的邮箱地址！',
              },
              {
                max: 50,
                message: '邮箱长度不能超过50位！',
              },
              {
                pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                message: '请输入有效的邮箱格式！',
              }
            ]}
          >
            <Input 
              className="register-input"
              prefix={<UserOutlined className="register-input-prefix" />} 
              placeholder="电子邮箱（选填）" 
            />
          </Form.Item>

          <Form.Item
            className="register-form-item"
            name="company_name"
            rules={[
              {
                required: true,
                message: '请输入公司名称！',
              },
              {
                min: 2,
                message: '公司名称长度至少为2位！',
              },
              {
                max: 100,
                message: '公司名称长度不能超过100位！',
              }
            ]}
          >
            <Input 
              className="register-input"
              prefix={<BankOutlined className="register-input-prefix" />} 
              placeholder="公司名称" 
            />
          </Form.Item>

          <Form.Item
            className="register-form-item"
            name="phone"
            rules={[
              {
                required: true,
                message: '请输入联系电话！',
              },
              {
                pattern: /^[0-9-+()]{8,20}$/,
                message: '请输入有效的电话号码格式！',
              }
            ]}
          >
            <Input 
              className="register-input"
              prefix={<PhoneOutlined className="register-input-prefix" />} 
              placeholder="联系电话" 
            />
          </Form.Item>

          <Form.Item
            className="register-form-item"
            name="address"
            rules={[
              {
                max: 200,
                message: '地址长度不能超过200位！',
              }
            ]}
          >
            <Input.TextArea 
              className="register-textarea"
              prefix={<HomeOutlined className="register-input-prefix" />} 
              placeholder="详细地址（选填）" 
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" className="register-button">
              注册
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Register;
